<template>
    <div >
        <DetailDevice :isBaoyang="true" :item="deviceInfo" :pid="deviceInfo.id" ></DetailDevice>
    </div>
</template>

<script>
    import DetailDevice from '@/views/index/projects/DetailDevice'
    import {deviceInfo} from "@/api/device";
    //import { mapGetters } from 'vuex'
    export default {
        name: '',
        components: {
            DetailDevice
        },
        data(){
            return {
                deviceInfo:{}
            }
        },
        computed: {
            /*...mapGetters([
                'deviceInfo'
            ])*/
        },
        methods: {

        },
        created() {
            let pid=Number(this.$route.query.pid)
            deviceInfo({pid:pid}).then(response => {
                if (response.code != 200) {
                    this.$message.error(response.msg)
                } else {
                    this.deviceInfo = response.data
                }
            })
            /*console.log(this.$router)
            console.log(this.$route)*/
        }
    }
</script>

<style scoped>

</style>
